import { adminCall, adminGet } from './adminCall';

export async function listAdminUsers() {
  const data = await adminGet('/api/admin/users');
  return data?.admins || [];
}

export async function registerAdminSelf(payload) {
  const data = await adminCall('/api/admin/register', payload || {});
  if (!data?.success) throw new Error(data?.error || 'Failed to register admin user');
  return data.admin;
}

export async function upsertAdminUser(payload) {
  const data = await adminCall('/api/admin/users', payload || {});
  if (!data?.success) throw new Error(data?.error || 'Failed to save admin user');
  return data.admin;
}

export async function updateAdminUserRole(id, role) {
  const data = await adminCall(`/api/admin/users/${encodeURIComponent(id)}/role`, { role });
  if (!data?.success) throw new Error(data?.error || 'Failed to update role');
  return data.admin;
}

export async function setAdminUserClaims(id) {
  const data = await adminCall(`/api/admin/users/${encodeURIComponent(id)}/claims`);
  if (!data?.success) throw new Error(data?.error || 'Failed to set admin claims');
  return data;
}

export async function deleteAdminUserRecord(id) {
  const data = await adminCall(`/api/admin/users/${encodeURIComponent(id)}/delete`);
  if (!data?.success) throw new Error(data?.error || 'Failed to delete admin');
  return data;
}
